import { render, staticRenderFns } from "./Paytype.vue?vue&type=template&id=5a7b46fb&scoped=true"
import script from "./Paytype.vue?vue&type=script&lang=js"
export * from "./Paytype.vue?vue&type=script&lang=js"
import style0 from "./Paytype.vue?vue&type=style&index=0&id=5a7b46fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b46fb",
  null
  
)

export default component.exports